<template>
  <article class="article-card" :class="{'article-card--small': small, 'article-card--max': max}" itemscope itemtype="http://schema.org/Article">

    <card-header :card="card" />
    <!-- <pre>id статьи: {{card.id}}</pre> -->
    <a :href="'/articles/' + locData.url_certain_lang" class="article-card__body" itemprop="url">
      <h3 class="article-card__title article-card__title--margin" itemprop="headline">{{locData.title}}</h3>
      <p class="article-card__content article-card__content--margin" itemprop="articleBody">{{locData.preview_text | cut(100, 'end')}}</p>
      <div class="article-card__preview">
        <img
          v-if="locData.index_img_resized"
          :src="`/uploads/${locData.index_img_resized}`"
          :alt="locData.title"
          class="article-card__preview-img"
          itemprop="image"
        >
      </div>
    </a>

    <!--<div class="article-card__footer mt-auto">-->
    <!--  <div class="article-card__comments mr-6"><i class="icon-comments footer&#45;&#45;icons"></i> 0</div>-->
    <!--  <div class="article-card__bookmarks"><i class="icon-bookmark footer&#45;&#45;icons"></i> 0</div>-->
    <!--  <div class="article-card__raiting ml-auto">-->
    <!--    <button class="rating-btn rating-btn&#45;&#45;down"><i class="icon-rating-arrow"></i></button>-->
    <!--    <span class="article-card__raiting-counter">0</span>-->
    <!--    <button class="rating-btn rating-btn&#45;&#45;up"><i class="icon-rating-arrow"></i></button>-->
    <!--  </div>-->
    <!--</div>-->
  </article>
</template>

<script>
import cardHeader from './CardHeader'
  export default {
    components: {
      cardHeader
    },
    props: {
      /**
       * Объект статьи
       */
      card: {
        type: [Object],
        required: true
      },
      /**
       * Маленькая карта для ЧЗ на главной. Ширина 445px
       */
      small: Boolean,
      /**
       * Ширина карточки максимальная - 100% от родителя
       */
      max: Boolean
    },
    computed: {
      locData() {
        return this.card.lang_versions[1] || {}
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
